export default "__VITE_ASSET__CMQuN8Oq__"